module.exports = __webpack_public_path__ + "media/960bn4.d9b1fe19.mp4";